import React, { FC, useCallback, useEffect, useState } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { MainHeadline } from 'components/Typography'
import { RadioButtonsForm, TextInput } from 'components/Form'
import { useStringChangeEvent } from 'hooks/form'
import { tagStatusOptions } from 'constants/options'
import { GreyButton, NavButton, OrangeButton } from 'components/Button'
import { useDispatch } from 'react-redux'
import { deleteTag, saveTag } from 'reducks/tag/operations'
import { db } from 'firebase/index'
import { TagType } from 'types/tag'
import { FormLabel } from 'components/Label'
import { CautionModal } from 'components/Modal'

type Props = {
  id: string | undefined
  isCreatePage: boolean
}

const TagsEditTemplate: FC<Props> = (props) => {
  const { id, isCreatePage } = props

  const dispatch = useDispatch()

  const [name, setName] = useState<string>('')
  const [isPublished, setPublished] = useState<string>('')
  const [open, setOpen] = useState<boolean>(false)

  const handleName = useStringChangeEvent(setName)
  const handlePublished = useStringChangeEvent(setPublished)
  const openModal = useCallback(() => setOpen(true), [setOpen])
  const closeModal = useCallback(() => setOpen(false), [setOpen])

  useEffect(() => {
    if (typeof id === 'undefined') return
    db.collection('tags')
      .doc(id)
      .get()
      .then((snapshot) => {
        const data = snapshot.data() as TagType
        setName(data.name)
        setPublished(data.is_published ? 'published' : 'unpublished')
      })
  }, [id])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={isCreatePage ? 'お店のオススメポイントを登録する' : 'オススメポイントを編集する'} />
      <Spacer size={28} />
      <TextInput
        disabled={false}
        label={'名前'}
        onChange={handleName}
        placeholder={'オススメポイントを入力してください'}
        required={true}
        size={'small'}
        type={'text'}
        value={name}
      />
      <Spacer size={28} />
      <FormLabel label={'公開・非公開'} required={true} />
      <Spacer size={8} />
      <RadioButtonsForm currentStatus={isPublished} options={tagStatusOptions} handleStatus={handlePublished} />
      {!isCreatePage && typeof id !== 'undefined' && (
        <>
          <Spacer size={48} />
          <NavButton
            iconPath={'/icon/grey/delete.svg'}
            label={'オススメポイントを削除する'}
            onClick={openModal}
            url={''}
          />
          <CautionModal
            actionLabel={'削除する'}
            cancelLabel={'キャンセル'}
            caution={'オススメポイントの削除'}
            closeModal={closeModal}
            description={'一度削除すると元に戻すことはできません。本当によろしいですか？'}
            open={open}
            onClickAction={() => dispatch(deleteTag(id))}
            onClickCancel={closeModal}
          />
        </>
      )}
      <Spacer size={48} />
      <OrangeButton
        disabled={name === '' || isPublished === ''}
        label={'保存する'}
        onClick={() => dispatch(saveTag(name, isPublished === 'published', id))}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={48} />
      <NavButton
        label={'登録されているオススメポイントへ'}
        iconPath={'/icon/grey/arrow_prev.svg'}
        url={'/admin/master/tags'}
      />
      <Spacer size={72} />
    </div>
  )
}

export default TagsEditTemplate
